$shm_ba_summary $mol_view
	table null
	selected? \Сообщений
	pick*? null
	sub <= cards /
	Card* $shm_ba_summary_card
		title <= card_title* \
		value <= card_value* \
		selected <= card_selected* false
		click? <=> pick*? null
